// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".export[data-v-0e671718]{width:calc(100% - 2.08333rem);margin-left:1.041667rem;display:flex;justify-content:right}", ""]);
// Exports
module.exports = exports;
